import React from "react";
import Lottie from "lottie-react";
import animation from "../loader.json";

export default function Loader ({ isCentered, width }) {
  const styles = {
    width: width || "5%"
  };

  if (isCentered) {
    styles.margin = "20% auto";
    // styles.justifyContent = "center";
  }

  return <div className="loader" style={styles}>
    <Lottie animationData={animation} loop={true} style={{ width: "100%" }} />
  </div>;
}
